<template>
  <div id="app">
    <!-- Salida de los avisos de PrimeVue (`this.$toast.add(...)`). El SERVICIO estaba
         registrado en main.js, pero este componente no se montaba en ninguna parte:
         los avisos se emitían al bus y NADIE los pintaba. Resultado: acciones que
         fallaban en silencio (p. ej. "no se pudo obtener el número de teléfono" al
         responder un WhatsApp) sin que el operador viera el motivo. -->
    <Toast position="top-right" :baseZIndex="1000000" />

    <audio
      id="audio"
      ref="notificationAudio"
      src="/notification.mp3"
      preload="auto"
      playsinline
    ></audio>

    <notifications
      position="top right"
      group="foo"
      class="notificacion-app lg"
      style="width: 417px; top: 21px; right: 24px"
    >
      <template slot="body" slot-scope="{ item, close }">
        <div class="vue-notification-template notfClas d-flex flex-row">
          <div class="icono">
            <i class="far fa-check-circle" v-if="item.data && item.data.type == 4"></i>
            <i class="fas fa-exclamation-triangle" v-else-if="item.data && item.data.type == 12"></i>
            <i class="fas fa-shield-alt" v-else-if="item.data && item.data.type == 13"></i>
            <i class="far fa-bell" v-else></i>
          </div>

          <div
            class="contenido d-flex flex-column"
            style="width: 88%; margin-left: 21px"
          >
            <p class="title">{{ item.title }}</p>
            <div class="body" v-html="item.text" />
          </div>

          <div class="cerrar">
            <button class="close" @click="close">
              <i class="fal fa-times"></i>
            </button>
          </div>
        </div>
      </template>
    </notifications>

    <!-- <button
      class="test-sound-btn"
      @click="triggerTestNotification"
      type="button"
    >
      Probar notificación
    </button> -->

    <loaderCarga v-if="$store.state.loader" />
    <modalDatos />

    <!-- Sin v-if: el componente queda montado y su <transition> interna (v-if
         "isModalVisible") anima la entrada/salida del drawer. Con v-if aquí, el
         montaje/desmontaje era instantáneo y la transición no llegaba a verse. -->
    <RerservationModal
      :visible.sync="$store.state.isVisibleModalBooking"
      :selectedRange="selectedRange"
      :bookingToEdit="$store.state.bookingToEdit"
    />

    <ChannexIncidentModal
      :visible="showChannexIncidentModal"
      @close="acknowledgeChannexIncidentModal"
    />

    <!-- Drawer de reserva GLOBAL: cualquier componente (campana/notificaciones,
         modal de notificaciones…) puede abrirlo emitiendo en el bus raíz
         `open-reservation-drawer` con { userId, reservaId } y, opcionalmente,
         { tab, chatId } para aterrizar en una pestaña/conversación concreta (lo usa
         la bandeja de mensajes del nav). Vive aquí para estar disponible en TODAS
         las páginas, no solo en el dashboard. -->
    <ReservationDrawer
      :visible.sync="reservationDrawer.visible"
      :user-id="reservationDrawer.userId"
      :reserva-id="reservationDrawer.reservaId"
      :initial-tab="reservationDrawer.tab"
      :initial-chat-id="reservationDrawer.chatId"
    />

    <!-- Centro de guías en video (lanzador flotante + drawer). Global y solo con
         sesión iniciada. Se puede abrir desde cualquier sitio con
         this.$root.$emit('open-video-guides'). -->
    <VideoGuides v-if="userRoot && !esVistaHuesped" />
    <NovedadesDrawer v-if="userRoot && !esVistaHuesped" />
    <!-- Recorrido de novedades: se abre solo encima del dashboard y desde la barra superior. -->
    <TourNovedades v-if="userRoot && !esVistaHuesped" />

    <router-view />
  </div>
</template>

<script>
import loaderCarga from "./components/Loaders/loaderCarga.vue";
import SocketioService from "./services/socketio.service.js";
import modalDatos from "./views/Template/Maqueta/modalDatos.vue";
import "./App.scss";
import RerservationModal from "@/components/components-global/RerservationModal.vue";
import ChannexIncidentModal from "@/components/Template/ChannexIncidentModal.vue";
import ReservationDrawer from "@/components/Reservas/ReservationDrawer.vue";
import VideoGuides from "@/components/App/VideoGuides.vue";
import NovedadesDrawer from "@/components/App/NovedadesDrawer.vue";
import TourNovedades from "@/components/App/TourNovedades.vue";
import Toast from "primevue/toast";
import { mapState } from "vuex";

const CHANNEX_INCIDENT_ACTIVE = false;
const CHANNEX_INCIDENT_STORAGE_KEY =
  "system-notice:channex-incident-2026-04-29-v1";

export default {
  components: {
    loaderCarga,
    modalDatos,
    RerservationModal,
    ChannexIncidentModal,
    ReservationDrawer,
    VideoGuides,
    NovedadesDrawer,
    TourNovedades,
    Toast,
  },

  created() {
    // Callback OAuth de Airbnb: si esta ventana es el popup de conexión (tiene opener) y
    // volvió con ?success=true&channel_id=…, avisa al opener y se cierra sola — así el wizard
    // continúa al mapeo en su sitio sin recargar el calendario.
    try {
      const p = new URLSearchParams(window.location.search);
      const chId = p.get("channel_id");
      if (chId && window.opener && window.opener !== window) {
        window.opener.postMessage({ type: "airbnb-connected", channel_id: String(chId) }, window.location.origin);
        window.close();
        return;
      }
    } catch (e) { /* noop */ }

    const socket = SocketioService.setupSocketConnection();

    this.handleSocketReconnect = () => {
      this.lastBoundUserId = null;
      if (this.$store.state.userRoot) {
        this.bindSocketListeners();
      }
    };

    this.handleGlobalSocketRebind = () => {
      this.lastBoundUserId = null;
      this.bindSocketListeners();
    };

    this.handleGlobalPlayNotificationSound = () => {
      this.playNotificationSound();
    };

    // Re-bind listeners after every (re)connection so that SPA navigation
    // never leaves us with a connected socket but no event handlers.
    socket.on("connect", this.handleSocketReconnect);

    // Escuchar petición de rebind desde páginas que detectan que el socket
    // puede estar conectado pero sin listeners activos (ej: PageReservation).
    this.$root.$on(
      "__rebind-socket-listeners__",
      this.handleGlobalSocketRebind
    );
  },

  data() {
    return {
      lastBoundUserId: null,
      audioUnlocked: false,
      audioUnlockListenersBound: false,
      notificationAudioContext: null,
      handleSocketReconnect: null,
      handleGlobalSocketRebind: null,
      handleGlobalPlayNotificationSound: null,
      showChannexIncidentModal: false,
      lastRealtimeEventKey: null,
      lastRealtimeEventAt: 0,
      // Drawer de reserva global (lo abre el bus raíz `open-reservation-drawer`).
      // tab/chatId son opcionales: sirven para aterrizar en una pestaña concreta
      // (whatsapp | web | otas) y abrir esa conversación.
      reservationDrawer: {
        visible: false,
        userId: null,
        reservaId: null,
        tab: null,
        chatId: null,
      },
    };
  },

  computed: {
    ...mapState([
      "isVisibleModalBooking",
      "selectedBookingRange",
      "propiedadActiva",
      "userRoot",
    ]),
    /*
     * Pantallas del huesped (tienda, bienvenida, ficha de servicio).
     *
     * Se mira `matched` y no `$route.meta` porque la marca esta en la ruta
     * PADRE y en vue-router 3 `meta` es la del registro mas profundo, no la
     * suma de todos.
     */
    esVistaHuesped() {
      return this.$route.matched.some((r) => r.meta && r.meta.huesped);
    },
    selectedRange() {
      return this.selectedBookingRange;
    },
    ...mapState("property", ["property", "properties"]),
  },

  async mounted() {
    this.restoreAudioPreference();
    this.setupGlobalAudioUnlock();
    this.syncChannexIncidentModal();

    // Exponer playNotificationSound globalmente para que cualquier componente
    // (ej. PageMensajes) pueda dispararlo sin duplicar código de audio.
    this.$root.$on(
      "play-notification-sound",
      this.handleGlobalPlayNotificationSound
    );

    // Abrir el drawer de reserva desde cualquier sitio (notificaciones, etc.).
    this.$root.$on("open-reservation-drawer", this.handleOpenReservationDrawer);

    window.addEventListener("focus", this.syncChannexIncidentModal);
    document.addEventListener("visibilitychange", this.handleDocumentVisibility);

    if (this.$store.state.userRoot) {
      if (!this.properties || this.properties.length === 0) {
        await this.$store.dispatch("property/getProperties");
      }

      this.ensureDefaultPropertySelected();
      this.bindSocketListeners();
    }
  },

  beforeDestroy() {
    this.unbindSocketListeners();
    this.$root.$off(
      "__rebind-socket-listeners__",
      this.handleGlobalSocketRebind
    );
    this.$root.$off(
      "play-notification-sound",
      this.handleGlobalPlayNotificationSound
    );
    this.$root.$off("open-reservation-drawer", this.handleOpenReservationDrawer);
    this.removeGlobalAudioUnlock();
    window.removeEventListener("focus", this.syncChannexIncidentModal);
    document.removeEventListener("visibilitychange", this.handleDocumentVisibility);
    if (SocketioService.socket && this.handleSocketReconnect) {
      SocketioService.socket.off("connect", this.handleSocketReconnect);
    }
    SocketioService.disconnect();
  },

  watch: {
    "$route.fullPath"() {
      this.syncChannexIncidentModal();
    },

    userRoot: {
      deep: true,
      handler() {
        if (!this.$store.state.userRoot) return;
        this.bindSocketListeners();
      },
    },

    properties: {
      deep: true,
      handler() {
        if (!this.$store.state.userRoot) return;
        this.ensureDefaultPropertySelected();
      },
    },

    // El arabe se lee de derecha a izquierda. Cualquier cambio de idioma (modal,
    // selector del panel o deteccion del navegador) pasa por i18n.locale, asi que
    // aqui es el unico sitio donde hay que voltear la direccion del documento.
    "$i18n.locale": {
      immediate: true,
      handler(loc) {
        this.applyLanguageDir(loc);
      },
    },
  },

  methods: {
    // RTL: fija dir/lang en <html> segun el idioma. Con dir="rtl" el navegador y
    // Bootstrap voltean la direccion base (texto, orden de los flex, alineaciones
    // logicas). Los margenes/paddings/floats fisicos se corrigen aparte en rtl.scss.
    applyLanguageDir(locale) {
      const isRtl = locale === "ar";
      const el = document.documentElement;
      el.setAttribute("dir", isRtl ? "rtl" : "ltr");
      el.setAttribute("lang", locale || "es");
    },

    restoreAudioPreference() {
      this.audioUnlocked = false;
    },

    // Abre el drawer lateral de la reserva. Lo dispara el bus raíz
    // `open-reservation-drawer` desde las notificaciones (campana, modal, lista).
    // La notificación guarda relation_id (booking_id) pero puede no llevar user_id:
    // se resuelve con el usuario en sesión (dueño del panel), igual que la vista
    // completa de la reserva.
    handleOpenReservationDrawer(payload = {}) {
      const reservaId = payload.reservaId || payload.reserva_id || null;
      if (!reservaId) return;
      const userId =
        payload.userId ||
        payload.user_id ||
        this.$store?.state?.userRoot?.id ||
        null;
      this.reservationDrawer = {
        visible: true,
        userId,
        reservaId,
        // Pestaña/conversación de destino (bandeja de mensajes del nav). Sin ellas
        // el drawer abre con su comportamiento de siempre.
        tab: payload.tab || null,
        chatId: payload.chatId || payload.chat_id || null,
      };
    },

    handleDocumentVisibility() {
      if (document.visibilityState === "visible") {
        this.syncChannexIncidentModal();
      }
    },

    hasAcknowledgedChannexIncidentModal() {
      if (!CHANNEX_INCIDENT_ACTIVE) return true;

      try {
        return localStorage.getItem(CHANNEX_INCIDENT_STORAGE_KEY) === "1";
      } catch (error) {
        return false;
      }
    },

    syncChannexIncidentModal() {
      this.showChannexIncidentModal =
        CHANNEX_INCIDENT_ACTIVE && !this.hasAcknowledgedChannexIncidentModal();
    },

    acknowledgeChannexIncidentModal() {
      try {
        localStorage.setItem(CHANNEX_INCIDENT_STORAGE_KEY, "1");
      } catch (error) {
        console.warn("[NOTICE] No se pudo persistir el aviso de Channex", error);
      }

      this.showChannexIncidentModal = false;
    },

    setupGlobalAudioUnlock() {
      if (this.audioUnlockListenersBound) return;

      const options = { passive: true };

      window.addEventListener("click", this.handleFirstUserInteraction, options);
      window.addEventListener("touchstart", this.handleFirstUserInteraction, options);
      window.addEventListener("keydown", this.handleFirstUserInteraction, options);

      this.audioUnlockListenersBound = true;
    },

    removeGlobalAudioUnlock() {
      window.removeEventListener("click", this.handleFirstUserInteraction);
      window.removeEventListener("touchstart", this.handleFirstUserInteraction);
      window.removeEventListener("keydown", this.handleFirstUserInteraction);
      this.audioUnlockListenersBound = false;
    },

    async handleFirstUserInteraction() {
      if (this.audioUnlocked) {
        this.removeGlobalAudioUnlock();
        return;
      }

      const unlocked = await this.unlockAudio();

      if (unlocked) {
        this.audioUnlocked = true;
        localStorage.setItem("notifications_audio_unlocked", "1");
        this.removeGlobalAudioUnlock();
      }
    },

    async unlockAudio() {
      const audio = this.$refs.notificationAudio;
      try {
        if (audio) {
          audio.volume = 1;
          audio.muted = false;
          audio.currentTime = 0;

          const playPromise = audio.play();
          if (playPromise && typeof playPromise.then === "function") {
            await playPromise;
          }

          audio.pause();
          audio.currentTime = 0;
        }

        await this.resumeNotificationAudioContext();

        return true;
      } catch (error) {
        console.warn("[AUDIO] No se pudo desbloquear todavía", error);
        return false;
      }
    },

    getNotificationAudioContext() {
      if (this.notificationAudioContext) {
        return this.notificationAudioContext;
      }

      const AudioCtx =
        window.AudioContext || window.webkitAudioContext || null;

      if (!AudioCtx) return null;

      this.notificationAudioContext = new AudioCtx();
      return this.notificationAudioContext;
    },

    async resumeNotificationAudioContext() {
      const ctx = this.getNotificationAudioContext();
      if (!ctx) return false;

      if (ctx.state === "suspended") {
        await ctx.resume();
      }

      return ctx.state === "running";
    },

    async playNotificationToneFallback() {
      try {
        const resumed = await this.resumeNotificationAudioContext();
        if (!resumed) return false;

        const ctx = this.notificationAudioContext;
        if (!ctx) return false;

        const now = ctx.currentTime;
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();

        oscillator.type = "sine";
        oscillator.frequency.setValueAtTime(880, now);
        oscillator.frequency.exponentialRampToValueAtTime(660, now + 0.16);

        gainNode.gain.setValueAtTime(0.0001, now);
        gainNode.gain.exponentialRampToValueAtTime(0.12, now + 0.02);
        gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.24);

        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);

        oscillator.start(now);
        oscillator.stop(now + 0.26);

        return true;
      } catch (error) {
        console.warn("[AUDIO] Fallback tone failed", error);
        return false;
      }
    },

    async playNotificationSound() {
      // Debounce: evitar que suene dos veces si llega el evento desde App y
      // desde PageMensajes casi simultáneamente (ventana de 500 ms).
      const now = Date.now();
      if (this._lastSoundTs && now - this._lastSoundTs < 500) return;

      const audio = this.$refs.notificationAudio;
      const source =
        audio?.currentSrc || audio?.src || `${window.location.origin}/notification.mp3`;

      try {
        const playbackAudio = new Audio(source);
        playbackAudio.preload = "auto";
        playbackAudio.volume = 1;
        playbackAudio.muted = false;
        playbackAudio.playsInline = true;

        const playPromise = playbackAudio.play();
        if (playPromise && typeof playPromise.then === "function") {
          await playPromise;
        }

        this._lastSoundTs = now;
        return;
      } catch (error) {
        console.warn("[AUDIO] Reproducción HTML5 bloqueada", error);
      }

      const playedFallback = await this.playNotificationToneFallback();

      if (playedFallback) {
        this._lastSoundTs = now;
        return;
      }

      this._lastSoundTs = 0;
      this.setupGlobalAudioUnlock();
    },

    async triggerTestNotification() {
      const fakeMsg = {
        title: "Notificación de prueba",
        mensaje: "Esta es una prueba de sonido y popup.",
        type: 6,
      };

      this.$store.state.state_notificacion = true;

      this.$notify({
        title: fakeMsg.title,
        text: fakeMsg.mensaje,
        data: fakeMsg,
        group: "foo",
        duration: 5000,
        classes: "notifications-active",
      });

      await this.playNotificationSound();
    },

    ensureDefaultPropertySelected() {
      const list = this.properties || [];
      if (list.length === 0) return;

      const storedRaw = localStorage.getItem("propiedadActiva");
      const storedId = storedRaw ? Number(storedRaw) : null;

      const isStoredValid =
        storedId && list.some((p) => Number(p.id) === Number(storedId));

      const defaultId = isStoredValid ? storedId : Number(list[0].id);

      if (!defaultId) return;

      localStorage.setItem("propiedadActiva", String(defaultId));
      localStorage.setItem("selectPropertyView", String(defaultId));

      if (this.$store._mutations?.setActiveProperty) {
        this.$store.commit("setActiveProperty", defaultId);
      } else {
        this.$store.state.propiedadActiva = defaultId;
        this.$store.state.selectPropertyView = defaultId;
      }
    },

    normalizeRealtimeId(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    },

    normalizeSocketConversation(payload = {}) {
      let conversation =
        payload?.conversation ??
        payload?.historial ??
        payload?.data?.conversation ??
        payload?.data?.historial ??
        null;

      if (typeof conversation === "string") {
        try {
          conversation = JSON.parse(conversation);
        } catch (error) {
          conversation = null;
        }
      }

      return Array.isArray(conversation) ? conversation : null;
    },

    extractLastSocketMessage(payload = {}) {
      const conversation = this.normalizeSocketConversation(payload);

      if (conversation?.length) {
        return (
          conversation
            .filter((msg) => msg?.role && !["system", "meta"].includes(msg.role))
            .slice(-1)[0] || null
        );
      }

      const candidate =
        payload?.message ??
        payload?.data?.message ??
        payload?.data?.last_message_object ??
        payload;

      if (!candidate || typeof candidate !== "object") return null;

      const hasMessageShape =
        candidate?.role ||
        candidate?.content ||
        candidate?.timestamp ||
        candidate?.wa_message_id ||
        Array.isArray(candidate?.attachments) ||
        candidate?.extra;

      return hasMessageShape ? candidate : null;
    },

    shouldPlaySocketNotificationSound(payload = {}) {
      const messageType =
        String(payload?.message_type || payload?.data?.message_type || "")
          .trim()
          .toLowerCase();

      if (messageType === "guest" || messageType === "user") {
        return true;
      }

      const message = this.extractLastSocketMessage(payload);

      return !!message && message?.role === "user" && message?.sent_by_agent !== true;
    },

    isConversationSocketPayload(payload = {}) {
      return !!(
        payload?.chat_id ||
        payload?.conversation_id ||
        payload?.crm_chat_id ||
        payload?.thread_id ||
        payload?.external_thread_id ||
        Array.isArray(payload?.conversation) ||
        Array.isArray(payload?.historial) ||
        payload?.message ||
        payload?.data?.message
      );
    },

    isPayloadForUser(payload = {}, userId) {
      const receptor = this.normalizeRealtimeId(payload?.receptor);
      const ownerUserId = this.normalizeRealtimeId(payload?.owner_user_id);
      const currentUserId = this.normalizeRealtimeId(userId);

      if (!currentUserId) return false;
      if (receptor && receptor === currentUserId) return true;
      if (ownerUserId && ownerUserId === currentUserId) return true;

      return false;
    },

    buildRealtimeEventKey(source, payload = {}) {
      const message = this.extractLastSocketMessage(payload);
      const conversation = this.normalizeSocketConversation(payload);

      return JSON.stringify({
        source,
        receptor: payload?.receptor || null,
        owner_user_id: payload?.owner_user_id || null,
        chat_id: payload?.chat_id || payload?.conversation_id || null,
        thread_id: payload?.thread_id || payload?.external_thread_id || null,
        message_id:
          message?.wa_message_id ||
          message?.id ||
          message?.extra?.message_id ||
          null,
        timestamp: message?.timestamp || null,
        content: String(message?.content || "").trim(),
        conversation_count: Array.isArray(conversation) ? conversation.length : null,
      });
    },

    async handleRealtimeConversationEvent(source, payload, userId) {
      if (!payload || typeof payload !== "object") return;

      console.log("[CRM-RT][App] realtime:event", {
        source,
        route: this.$route?.name || null,
        user_id: userId,
        receptor: payload?.receptor || null,
        owner_user_id: payload?.owner_user_id || null,
        chat_id: payload?.chat_id || payload?.conversation_id || null,
        thread_id: payload?.thread_id || payload?.external_thread_id || null,
        has_conversation: Array.isArray(payload?.conversation),
        conversation_count: Array.isArray(payload?.conversation)
          ? payload.conversation.length
          : null,
        has_message: !!(payload?.message || payload?.data?.message),
      });

      const dedupeKey = this.buildRealtimeEventKey(source, payload);
      const now = Date.now();

      if (
        this.lastRealtimeEventKey === dedupeKey &&
        now - Number(this.lastRealtimeEventAt || 0) < 1200
      ) {
        console.log("[CRM-RT][App] realtime:event skipped by dedupe", {
          source,
          dedupeKey,
        });
        return;
      }

      this.lastRealtimeEventKey = dedupeKey;
      this.lastRealtimeEventAt = now;

      this.$root.$emit("crm-socket-conversation-payload", {
        source,
        payload,
      });

      console.log("[CRM-RT][App] emitted to root", {
        source,
        chat_id: payload?.chat_id || payload?.conversation_id || null,
      });

      const shouldSkipBackgroundChatRefresh = ["PageMensajes", "ReservasID"].includes(
        this.$route?.name
      );

      if (!shouldSkipBackgroundChatRefresh) {
        await this.$store.dispatch("chatbot/retrieveGlobalChats", {
          user_id: userId,
          property_id: "all",
          channel: payload?.channel || "whatsapp",
        });

        await this.refreshReservationRealtimeChats(payload);
      }

      if (this.shouldPlaySocketNotificationSound(payload)) {
        await this.playNotificationSound();
      }
    },

    getActiveReservationRouteId() {
      return this.normalizeRealtimeId(this.$route?.params?.reserva);
    },

    async refreshReservationRealtimeChats(payload = {}) {
      const userId = this.$store.state.userRoot?.id;
      const reservationId =
        this.normalizeRealtimeId(payload?.reserva_id) ||
        this.normalizeRealtimeId(payload?.reservation_id) ||
        this.normalizeRealtimeId(payload?.booking_id) ||
        this.getActiveReservationRouteId();

      if (!userId || !reservationId) return;

      const propertyId =
        this.normalizeRealtimeId(payload?.property_id) ||
        this.normalizeRealtimeId(payload?.propiedad_id) ||
        "all";

      await this.$store.dispatch("chatbot/retrieveReservationChats", {
        user_id: userId,
        property_id: propertyId,
        reservation_id: reservationId,
        channel: payload?.channel || "whatsapp",
      });
    },

    bindSocketListeners() {
      const userId = this.$store.state.userRoot?.id;

      if (!SocketioService.socket || !userId) return;
      if (this.lastBoundUserId === userId) return;

      this.unbindSocketListeners();
      this.lastBoundUserId = userId;

      SocketioService.socket.on(
        `new-conversation-user-${userId}`,
        async (payload) => {
          console.log("[CRM-RT][App] scoped socket:new-conversation-user", payload);
          await this.handleRealtimeConversationEvent(
            "new-conversation-user",
            payload,
            userId
          );
        }
      );

      SocketioService.socket.on(`chat-message-${userId}`, async (msg) => {
        console.log("[CRM-RT][App] scoped socket:chat-message", msg);
        // type 5 = cambio de calendario (precios/disponibilidad). No genera
        // notificación ni sonido, pero sí avisa a la vista de calendario activa
        // para que refresque en vivo también cuando el cambio nació en la app.
        if (msg && Number(msg.type) === 5) {
          this.$root.$emit("calendar-realtime-changed", msg);
          return;
        }
        // Reserva marcada 'silent': su campana (notification-{userId}) YA muestra el toast.
        // Aquí solo refrescamos la lista de la campana (sin toast ni sonido) para no duplicar.
        if (msg && (msg.silent === true || msg.silent === 1)) {
          this.$funtion.Notifications();
          return;
        }
        if (this.isConversationSocketPayload(msg)) {
          await this.handleRealtimeConversationEvent("chat-message", msg, userId);
          return;
        }

        this.$funtion.Notifications();
        this.$store.state.state_notificacion = true;

        this.$notify({
          title: msg.title,
          text: msg.mensaje,
          data: msg,
          group: "foo",
          duration: 5000,
          classes: "notifications-active",
        });

        await this.playNotificationSound();
      });

      SocketioService.socket.on(`new-conversation`, async (payload) => {
        if (!this.isPayloadForUser(payload, userId)) return;
        console.log("[CRM-RT][App] generic socket:new-conversation", payload);
        await this.handleRealtimeConversationEvent(
          "new-conversation-generic",
          payload,
          userId
        );
      });

      SocketioService.socket.on(`chat-message`, async (payload) => {
        if (!this.isPayloadForUser(payload, userId)) return;
        console.log("[CRM-RT][App] generic socket:chat-message", payload);

        // El evento genérico puede llegar además del canal scoped. Las vistas
        // aplican debounce para convertir ambos en un único refresco silencioso.
        if (payload && Number(payload.type) === 5) {
          this.$root.$emit("calendar-realtime-changed", payload);
          return;
        }

        // Reserva 'silent': la campana (notification-{userId}) ya pinta el toast → no duplicar.
        if (payload && (payload.silent === true || payload.silent === 1)) {
          this.$funtion.Notifications();
          return;
        }

        if (this.isConversationSocketPayload(payload)) {
          await this.handleRealtimeConversationEvent(
            "chat-message-generic",
            payload,
            userId
          );
          return;
        }

        this.$funtion.Notifications();
        this.$store.state.state_notificacion = true;

        this.$notify({
          title: payload.title,
          text: payload.mensaje,
          data: payload,
          group: "foo",
          duration: 5000,
          classes: "notifications-active",
        });

        await this.playNotificationSound();
      });

      SocketioService.socket.on(`crm-debug-message-user-${userId}`, async (payload) => {
        console.log("[CRM-RT][App] scoped socket:crm-debug-message-user", payload);
        await this.handleRealtimeConversationEvent(
          "crm-debug-message",
          payload,
          userId
        );
      });

      // Pago de servicio confirmado (late checkout / early check-in / ampliación):
      // reenviamos un evento global para que el dashboard y el drawer de la reserva
      // refresquen en vivo. try/catch para no romper el handler del socket.
      SocketioService.socket.on(`service-payment-confirmed-${userId}`, (payload) => {
        console.log("[CRM-RT][App] socket:service-payment-confirmed", payload);
        try {
          this.$root.$emit("service-payment-confirmed", payload || {});
        } catch (e) {
          console.warn("[CRM-RT][App] error reenviando service-payment-confirmed", e);
        }
      });

      // Notificación persistida (campana): limpieza y otros procesos. Refrescamos la
      // lista, marcamos no leído y avisamos (toast + sonido). El payload trae
      // title/body/type; si faltara, mostramos un aviso genérico.
      SocketioService.socket.on(`notification-${userId}`, async (payload) => {
        console.log("[CRM-RT][App] socket:notification", payload);
        try {
          this.$funtion.Notifications();
          this.$store.state.state_notificacion = true;
          // Solicitudes de Recepción IA (type 6, p. ej. derivación al anfitrión):
          // refresca el widget del dashboard en tiempo real (escucha este evento).
          if (Number(payload?.type) === 6) {
            this.$root.$emit("service-payment-confirmed", payload);
          }
          this.$notify({
            title: payload?.title || "Nueva notificación",
            text: payload?.body || "",
            data: payload,
            group: "foo",
            duration: 5000,
            classes: "notifications-active",
          });
          await this.playNotificationSound();
        } catch (e) {
          console.warn("[CRM-RT][App] error manejando notification", e);
        }
      });
    },

    unbindSocketListeners() {
      if (!SocketioService.socket) return;

      const userId = this.lastBoundUserId || this.$store.state.userRoot?.id;

      if (userId) {
        SocketioService.socket.off(`new-conversation-user-${userId}`);
        SocketioService.socket.off(`chat-message-${userId}`);
        SocketioService.socket.off(`new-conversation`);
        SocketioService.socket.off(`chat-message`);
        SocketioService.socket.off(`crm-debug-message-user-${userId}`);
        SocketioService.socket.off(`service-payment-confirmed-${userId}`);
        SocketioService.socket.off(`notification-${userId}`);
      }

      this.lastBoundUserId = null;
    },
  },
};
</script>

<style scoped>
.test-sound-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 99999;
  border: none;
  border-radius: 12px;
  padding: 10px 14px;
  font-weight: 700;
  font-size: 13px;
  background: #7c3aed;
  color: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  cursor: pointer;
}
</style>
